import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { QuestionarioIegm } from "@/types/questionarios/questionario-iegm";

const questionarioService = {
  getQuestionariosIegm,
};

async function getQuestionariosIegm(): Promise<QuestionarioIegm[]> {
  const url = process.env.VUE_APP_ENTREGAS_API + "/questionario/iegm";
  const response = await Service.$http.get(url);
  //console.log("sou o questionarioService.getQuestionariosIegm. Response ",response);
  if (!response || response.status !== 200)
    throw new PortalError("Falha ao obter questionários do IEGM.");
  return response.data.map((item: any) => new QuestionarioIegm(item));
}

export default questionarioService;
